import type { FC } from 'react';
import BroadcastIcon from '@public/assets/sport/icons/broadcastCamera.svg';
import WhistleIcon from '@public/assets/sport/icons/matchWhistle.svg';
import WidgetInfo from '@public/assets/sport/icons/widgetInfo.svg';
import widgetBgImage from '@public/assets/sport/images/widgetBg.webp';
import { Image } from '@/components/Image/Image';
import { SignUpButton } from './components/SignUpButton/SignUpButton';
import { getBannerText } from './WidgetBanner.utils';
import styles from './WidgetBanner.module.scss';
export interface WidgetLoginBannerProps {
  isAuth: boolean;
  isLineFinished: boolean;
  isLineNotStarted: boolean;
  title?: string;
}
export const WidgetBanner: FC<WidgetLoginBannerProps> = ({
  isAuth,
  isLineFinished,
  isLineNotStarted,
  title
}) => {
  const bannerText = getBannerText({
    isAuth,
    isLineFinished,
    isLineNotStarted
  });
  const LoginContent = <>
      <WidgetInfo className={styles.bannerIcon} />
      <span className={styles.bannerText}>{bannerText}</span>
      <SignUpButton />
    </>;
  const BroadcastEndContent = <>
      <WhistleIcon width="40" height="40" className={styles.bannerIcon} />
      <span className={styles.bannerText}>{bannerText}</span>
    </>;
  const BroadcastNotStartedContent = <>
      <BroadcastIcon width="40" height="40" className={styles.bannerIcon} />
      <span className={styles.bannerText}>{bannerText}</span>
    </>;
  return <div className={styles.banner} data-sentry-component="WidgetBanner" data-sentry-source-file="WidgetBanner.tsx">
      <Image src={widgetBgImage} alt={title ?? 'widget banner bg image'} fill style={{
      objectFit: 'cover'
    }} data-sentry-element="Image" data-sentry-source-file="WidgetBanner.tsx" />

      {!isAuth && LoginContent}
      {isAuth && isLineFinished && BroadcastEndContent}
      {isAuth && isLineNotStarted && BroadcastNotStartedContent}
    </div>;
};